import { GetServerSideProps } from 'next';
import { getIntlProps } from '@moxy/next-intl';
import { QuestionDetail } from '../../src/containers/pages/questions/categories/types';
import { QuestionDetailsPage } from '../../src/containers/pages/questions/QuestionDetailsPage';
import { config } from '../../src/config/config';

// eslint-disable-next-line import/no-default-export
export default QuestionDetailsPage;

export const getServerSideProps: GetServerSideProps<{
  questionDetails: QuestionDetail;
}> = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  const id = ctx.query.id as string;

  const response = await fetch(`${config.serverAPI}questions/${id}/`);
  const results = await response.json();

  return {
    props: {
      questionDetails: results,
      ...(await getIntlProps(ctx.locale))
    }
  };
};
